import { Machine } from "xstate";

const resetPasswordMachine = Machine({
  id: "reset-password",
  initial: "verify",
  states: {
    verify: {
      on: {
        RESOLVE: "idle",
        REJECT: "failure",
      },
    },
    idle: {
      on: {
        RESET: "loading",
      },
    },
    failure: {
      type: "final",
    },
    loading: {
      on: {
        RESOLVE: "success",
        REJECT: "idle",
      },
    },
    success: {
      type: "final",
    },
  },
});

export default resetPasswordMachine;
